import { Text } from "@/components/ui/text";
import { formatReceivedAtDisplay } from "../lib/receive-timezone";

export function ReceivedAtDisplay({
  receivedAt,
  receiveTimezone,
}: {
  receivedAt: Date | string | null | undefined;
  receiveTimezone: string | null;
}) {
  const { formatted, missingConfiguredTimezone } = formatReceivedAtDisplay(
    receivedAt,
    receiveTimezone,
  );

  if (!formatted) {
    return null;
  }

  return (
    <div className="flex flex-col gap-0.5">
      <span>{formatted}</span>
      {missingConfiguredTimezone ? (
        <Text size="1" muted>
          Receiving lab timezone not configured
        </Text>
      ) : null}
    </div>
  );
}
